<template>
  <img v-if="url" :src="faviconDataUrl" class="favicon" :class="{ rounded }"
    :style="{ width: sizePx, height: sizePx, 'font-size': fontSizePx, position: position }" />
</template>
<script>
import commonUtil from "@/utils/commonUtil";
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    rounded: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: Number,
      required: false,
      default: 16,
    },
    position: {
      type: String,
      required: false,
      default: 'static',
    }
  },
  data() {
    return {
      faviconDataUrl: "", // holds the base64 image
    };
  },
  watch: {
    url: {
      immediate: true, // run on initial mount too
      handler(newUrl) {
        if (newUrl) {
          this.fetchFavicon();
        } else {
          this.faviconDataUrl = '';
        }
      }
    }
  },
  methods: {
    fetchFavicon() {
      const domain = this.domain;
      if (!domain) {
        this.faviconDataUrl = '';
        return;
      }
      const cachedFavicon = this.getFavicon(domain);
      const pendingFavicon = this.getPendingFavicon(domain);
      if (cachedFavicon) {
        this.faviconDataUrl = cachedFavicon;
        return;
      }
      
      if (pendingFavicon) {
        //if favicon is pending from another call, wait for it and keep checking every 100ms
        const checkInterval = setInterval(() => {
          const newCached = this.getFavicon(domain);
          const stillPending = this.getPendingFavicon(domain);
          if (newCached && !stillPending) {
            this.faviconDataUrl = newCached;
            clearInterval(checkInterval);
          }
        }, 100); // Check every 100ms
        return;
      }
      this.setPendingFavicon({ domain, pending: true });
      this.$api.getFavicon(domain)
      .then(res => {
        this.faviconDataUrl = res.data;
        this.setFavicon({ domain, data: res.data });
        this.setPendingFavicon({ domain, pending: false });
      })
      .catch(() => {
        this.faviconDataUrl = "";
        this.setPendingFavicon({ domain, pending: false });
      });
    },
    ...mapActions('favicons', ['setFavicon', 'setPendingFavicon']),
  },
  computed: {
    domain() {
      return commonUtil.extractDomain(this.url);
    },
    sizePx() {
      return this.size + 'px';
    },
    fontSizePx() {
      return Math.floor(this.size * .9) + 'px';
    },
    ...mapGetters('favicons', ['getFavicon', 'getPendingFavicon']),
  },
}
</script>
<style lang="scss" scoped>
.favicon {
  max-width: 100%;
  max-height: 100%;
  display: block;
  &.bi:before {
    color: var(--disabled-text-color);
    vertical-align: .1rem;
  }
  &.rounded {
    border-radius: 40px;
    box-shadow: 0px 0px 3px var(--timeline-card-shadow-color);
    overflow: hidden;
  }
}
</style>